module.exports = __webpack_public_path__ + "static/pexels-cottonbro-4039184-be742ff3051dcf66b94002e6f894a015.jpg";